<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    商品管理
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3">
                            <wj-menu [(value)]="readonly" [isDisabled]="products.hasChanges()" [header]="'編集モード'">
                                <wj-menu-item [value]="true">ロック</wj-menu-item>
                                <wj-menu-item [value]="false">編集可能</wj-menu-item>
                            </wj-menu>
                        </div>
                        <div class="col-md-3"><span>該当　{{products.totalCount|number}}　件</span></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <wj-flex-grid #productGrid [allowAddNew]="true" [allowDelete]="true" [isReadOnly]="readonly" style="height:500px" [itemsSource]="products">
                                <wj-flex-grid-filter></wj-flex-grid-filter>
                                <wj-flex-grid-column [header]="'カテゴリ'" [binding]="'category'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'名称'" [binding]="'name'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'メーカー'" [binding]="'manufacture'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'型番'" [binding]="'model'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'金額'" [binding]="'price'" [dataType]="'Number'" [width]="100"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'単位'" [binding]="'unit'" [width]="100"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'備考'" [binding]="'memo'" [width]="150"></wj-flex-grid-column>
                            </wj-flex-grid>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div style="float:left; min-width: 150px;">
                            <wj-menu [(value)]="products.pageSize" [header]="'ページサイズ'">
                                <wj-menu-item [value]="100">100</wj-menu-item>
                                <wj-menu-item [value]="500">500</wj-menu-item>
                                <wj-menu-item [value]="1000">1000</wj-menu-item>
                            </wj-menu>
                        </div>
                        <div style="float:left; min-width: 150px;">
                            <wj-collection-view-navigator [cv]="products"></wj-collection-view-navigator>
                        </div>
                        <div style="float:left; min-width: 150px;">
                            <wj-collection-view-pager [cv]="products"></wj-collection-view-pager>
                        </div>
                    </div>
                    <div class="row">
                        <button *ngIf="!readonly" [disabled]="!products.hasChanges()" (click)="products.saveChanges()" class="btn btn-primary btn-block">変更保存</button>
                        <button *ngIf="!readonly" [disabled]="!products.hasChanges()" (click)="products.cancelChanges()" class="btn btn-primary btn-block">キャンセル</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
